export const developData = [
  {
    id: 1,
    title: "Define Trading Strategy",
    num: "01",
    content:
      "Before starting forex trading bot development, outline a clear trading strategy based on technical and fundamental analysis.",
  },
  {
    id: 2,
    title: "Choose a Programming Language",
    num: "02",
    content:
      "Popular choices for forex trading bot development include Python, Java, C++, and JavaScript.",
  },
  {
    id: 3,
    title: " Integrate with a Forex API",
    num: "03",
    content:
      "Connect your bot with forex trading platforms such as MetaTrader 4 (MT4), MetaTrader 5 (MT5), or cTrader, NinjaTrader for real-time market data.",
  },
  {
    id: 4,
    title: "Implement Trading Algorithms",
    num: "04",
    content:
      "Write code to execute trades based on market signals, trends, and risk management principles.",
  },
  {
    id: 5,
    title: "Backtest and Optimize Performance",
    num: "05",
    content:
      "Run extensive backtests using historical data to refine trading algorithms and improve accuracy.",
  },
  {
    id: 6,
    title: "Deploy and Monitor",
    num: "06",
    content:
      "Launch your forex trading bot on a demo or live trading account and continuously monitor its performance.",
  },
];

export const techData = [
  {
    id: 1,
    img: require("../../../image/forextradingbot/tech-img-one.webp"),
    title: "Artificial Intelligence (AI)",
    content:
      "AI-powered bots analyze large datasets and adapt trading strategies based on real-time market conditions.",
  },
  {
    id: 2,
    img: require("../../../image/forextradingbot/tech-img-two.webp"),
    title: "Blockchain for Secure Transactions",
    content:
      "Blockchain technology enhances transparency and security in forex trading bot operations.",
  },
  {
    id: 3,
    img: require("../../../image/forextradingbot/tech-img-three.webp"),
    title: "Cloud Computing for Scalability",
    content:
      "Cloud-based forex bots allow seamless integration and faster trade execution with minimal latency.",
  },
  {
    id: 4,
    img: require("../../../image/forextradingbot/tech-img-four.webp"),
    title: "High-Frequency Trading (HFT) Algorithms",
    content:
      "HFT strategies execute thousands of trades per second, maximizing profit opportunities in volatile forex markets.",
  },
];
